module.exports = __webpack_public_path__ + "static/media/vip_bg_4.e0894398.png";